import { TimerIcon } from "@phosphor-icons/react";
import { PhosphorIcon } from "../../../basic/phosphorIcon/PhosphorIcon";

interface OnlineTestTimerProps {
    timeRemaining?: string;
    isTimeRunningOut?: boolean;
    shouldBounceTimer?: boolean;
    onBounceEnd?: () => void;
}

const OnlineTestTimer = (props: OnlineTestTimerProps) => {
    if (!props.timeRemaining) return null;

    const timerColor = props.isTimeRunningOut ? "text-p6-orange" : "text-p6-grey-dark";
    const bounceClass = props.shouldBounceTimer ? "animate-bounce-once" : "";

    return (
        <div
            className={`flex flex-row items-center gap-xs ${bounceClass}`}
            onAnimationEnd={props.onBounceEnd}
        >
            <PhosphorIcon
                phosphorIcon={TimerIcon}
                color={timerColor}
                fontSize="text-[30px]"
            />
            <span className={`text-l ${timerColor}`}>{props.timeRemaining}</span>
        </div>
    );
};

export default OnlineTestTimer;
